import React from 'react';

import View from 'components/View';
import CoachingViewHeader from 'coaching/components/CoachingViewHeader';

import './styles/CoachingView.scss';

type Props = {
  children: React.ReactNode;
};

export default function CoachingView({ children }: Props) {
  return (
    <div className="CoachingView">
      <CoachingViewHeader title="Remind Coaching" />
      <View scroll>{children}</View>
    </div>
  );
}
